import React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps, IButtonProps, IIconBaseProps, useChooseRef } from '@agilepoint/wat-react-ux';
import { IconButton } from '../icon-button';

export interface ICustomFileUploadProps extends IBaseComponentProps<HTMLInputElement>, Omit<IButtonProps, 'elementRef' | 'ref'>, IIconBaseProps {
    accept?: string;
    multiple?: boolean;
    onValueChange?: (files: File[]) => void;
}

const NativeFileInput = styled.input.attrs({
    type: 'file'
})`
    display: none;
`;

export const CustomFileUpload = React.memo((props: ICustomFileUploadProps) => {
    const { accept, multiple, className, elementRef, onValueChange, iconName = 'ap-export2.outline', ...buttonProps } = props;

    const inputRef = useChooseRef<HTMLInputElement>(elementRef);

    const _onFileChangeHandler = React.useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
        if (ev.target.files?.length) {
            const files = Array.from(ev.target.files);
            onValueChange && onValueChange(files);
        }
    }, [onValueChange]);

    /* when a same file is uploaded the onchange event is not being fired
     * due to which we need to attach an onclick event,
     * and set empty string as value.
     */
    const onInputClick = React.useCallback((event) => {
        event.target.value = '';
    }, []);

    const _onButtonClick = React.useCallback(() => {
        const { current } = inputRef;
        current?.click();
    }, [inputRef]);

    return (
        <>
            <IconButton
                type="button"
                iconName={iconName}
                className={className}
                onClick={_onButtonClick}
                {...buttonProps} />
            <NativeFileInput
                ref={inputRef}
                accept={accept}
                multiple={multiple}
                onClick={onInputClick}
                onChange={_onFileChangeHandler} />
        </>
    );
});
